import styles from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import { MailListItemDraftsPlaceholder } from '../index';
import classnamesBind from 'classnames/bind';
import { observer } from 'mobx-react-lite';
import { getDensityModeString } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { highlightTermsInHtmlElement } from 'owa-highlight';
import { getMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/getMessageListTextStyle';
import { UnreadReadCountBadge } from 'owa-unreadread-count-badge';
import * as React from 'react';

const classNames = classnamesBind.bind(styles);

export interface MailListItemFirstLineTextProps {
    highlightTerms: string[];
    showDraftsIndicator: boolean;
    unreadCount: number;
    text: string;
    tooltipText: string;
}

export default observer(function MailListItemFirstLineText(props: MailListItemFirstLineTextProps) {
    const {
        highlightTerms: _highlightTerms,
        showDraftsIndicator,
        text,
        tooltipText,
        unreadCount,
    } = props;

    const showUnreadCountBadge =
        unreadCount > 1 && isFeatureEnabled('mon-tri-unreadCountBadgeWithBackground');

    const firstLineTextClasses = classNames(
        unreadCount > 0 ? styles.firstLineTextUnread : styles.firstLineTextRead,
        showUnreadCountBadge && styles.hasCountBadge,
        isFeatureEnabled('mon-densities') &&
            getMessageListTextStyle('Major', getDensityModeString(), true)
    );

    const highlightTerms = React.useCallback(
        (element: HTMLElement) => {
            highlightTermsInHtmlElement(
                element,
                _highlightTerms,
                false /* separateWordSearch */,
                true /* matchPrefix */
            );
        },
        [_highlightTerms]
    );

    return (
        <>
            <div className={firstLineTextClasses}>
                {showDraftsIndicator && <MailListItemDraftsPlaceholder />}
                <span title={tooltipText} ref={highlightTerms}>
                    {text}
                </span>
            </div>
            {showUnreadCountBadge && (
                <UnreadReadCountBadge
                    count={unreadCount}
                    isListViewBadge={true}
                    isSelected={true}
                />
            )}
        </>
    );
});
